import { render, staticRenderFns } from "./UserAccessRequestsRejectedPage.vue?vue&type=template&id=422a9873&scoped=true"
import script from "./UserAccessRequestsRejectedPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserAccessRequestsRejectedPage.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a9873",
  null
  
)

export default component.exports